import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Link} from "react-router-dom";
import OnlineMarket from "./lazizbek/OnlineMarket";
import FullProduct from "./abdulaziz/FullProduct";

class HomePage extends Component {
    render() {
        return (
            <div>
                <OnlineMarket/>
            </div>
        );
    }
}

HomePage.propTypes = {};

export default HomePage;
